<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-warehouse"></i></span>
    {{ "CustomsClearanceShippingReport.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm" class="field">
          <div class="p-fluid formgrid grid">
            <div class="field col-3">
              <label>
                {{
                  "CustomsClearanceShippingReport.Form.CustomsDeclarationNo"
                    | translate
                }}
              </label>
              <p-chips
                formControlName="customsDeclarationNoList"
                separator=","
                (onAdd)="chipsAdd($event, 'customsDeclarationNoList')"
              ></p-chips>
            </div>

            <div class="field col-3">
              <label>{{
                "CustomsClearanceShippingReport.Form.RefNo" | translate
              }}</label>
              <p-chips
                formControlName="refNoList"
                separator=","
                (onAdd)="chipsAdd($event, 'refNoList')">
              </p-chips>
            </div>

            <div class="field col-3">
              <label>{{
                "CustomsClearanceShippingReport.Form.AdNoAndDoNo" | translate
              }}</label>
              <p-chips
                formControlName="adNoAndDoNoList"
                separator=","
                (onAdd)="chipsAdd($event, 'adNoAndDoNoList')">
              </p-chips>
            </div>

            <div class="field col-3">
              <laas-customer-dropdown
                #customerOptions
                [divClass]="'field'"
                [permissionCode]="permissionCode"
                [showLabel]="true"
                [isMultiple]="true"
                formControlName="consigneeKeyList"
              >
              </laas-customer-dropdown>
            </div>

            <div class="field col-3 laas-calendar">
              <laas-calendar
                #date
                [title]="'CustomsClearanceShippingReport.Form.Date'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'date')"
              ></laas-calendar>
            </div>

            <div class="field col-3">
              <label>{{
                "CustomsClearanceShippingReport.Form.CustomsClearanceType"
                  | translate
              }}</label>
              <div class="item">
                <p-multiSelect
                  [options]="customsClearanceTypeOptions"
                  formControlName="customsClearanceTypeList"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  filterBy="label">
                </p-multiSelect>
              </div>
            </div>

            <!-- <div class="field col-3">
              <label>{{ 'CustomsClearanceShippingReport.Form.BondNo' | translate }}</label>
              <p-chips
                formControlName="bondNoList"
                separator=","
                (onAdd)="chipsAdd($event, 'bondNoList')"
              />
            </div> -->

            <!-- <div class="field col-3">
              <label>{{ 'CustomsClearanceShippingReport.Form.CtmCode' | translate }}</label>
              <p-chips
                formControlName="ctmCodeList"
                separator=","
                (onAdd)="chipsAdd($event, 'ctmCodeList')"
              />
            </div>

            <div class="field col-3 laas-calendar">
              <laas-calendar
                #createDate
                [title]="'CustomsClearanceShippingReport.Form.CreateDate'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'createDate')"
              ></laas-calendar>
            </div> -->
          </div>
        </form>
        <div class="grid align-items-center vertical-container">
          <button
            pButton
            pRipple
            label="{{ 'Common.Button.Search' | translate }}"
            class="p-button-raised"
            (click)="searchBtnClick()"
          ></button>

          <button
            pButton
            pRipple
            label="{{ 'Common.Button.Reset' | translate }}"
            class="p-button-secondary ml-2"
            (click)="resetBtnClick()"
          ></button>
        </div>
      </p-accordionTab>
    </p-accordion>

    <div class="mt-2">
      <laas-data-table
        #headerTable
        [dataKey]="'seqNo'"
        [tableKey]="preferenceKey"
        [value]="customsClearanceShippingReportData"
        [defaultColumns]="columns"
        [loading]="isLoading"
        [lazy]="true"
        [totalRecords]="pageInfo.totalRecords"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [expandable]="true"
        (rowExpanded)="searchDetailClick($event)"
      >
        <ng-template pTemplate="caption">

          <button
            pButton
            pRipple
            label="{{ 'CustomsClearanceShippingReport.Button.UploadFile' | translate }}"
            icon="pi pi-file"
            class="p-button-raised ml-2"
            (click)="uploadFile()"
          ></button>

          <button
            pButton
            pRipple
            label="{{ 'Common.Button.DownloadExcel' | translate }}"
            icon="pi pi-file"
            class="p-button-raised p-button-success ml-2"
            [disabled]="!headerTable?.selectedRow"
            (click)="downloadFile('XLS')"
          ></button>

          <button
            pButton
            pRipple
            label="{{ 'Common.Button.DownloadPdf' | translate }}"
            icon="pi pi-file"
            class="p-button-raised p-button-success ml-2"
            [disabled]="!headerTable?.selectedRow"
            (click)="downloadFile('PDF')"
          ></button>

          <button
            pButton
            pRipple
            label="{{ 'Common.Button.DownloaCustomsTrade' | translate }}"
            icon="pi pi-file"
            class="p-button-raised p-button-success ml-2"
            [disabled]="!headerTable?.selectedRow"
            (click)="downloadCustomsTrade()"
          ></button>

        </ng-template>
        <ng-template
          pTemplate="body"
          let-rowData
          let-columns="columns"
          let-expanded="expand"
        >
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
                {{
                  rowData[col.field] | optionsMapping : this.customerOptions.customerOptions | replaceNullWith : '-'
                }}
              </ng-container>

              <ng-container *ngSwitchCase="'customsClearanceType'" class="p-fluid">
                {{
                  rowData[col.field] | optionsMapping : this.customsClearanceTypeOptions | replaceNullWith : '-'
                }}
              </ng-container>

              <ng-container *ngSwitchCase="'updateUser'" class="p-fluid">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : this.userOptions
                      | replaceNullWith : '-'
                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'createUser'" class="p-fluid">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : this.userOptions
                      | replaceNullWith : '-'
                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | date
                            : "yyyy-MM-dd HH:mm:ss"
                            : this.laasSetting.facilityTimeZone
                          | replaceNullWith : '-'
                      }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith : '-' }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
        <ng-template
          pTemplate="rowexpansion"
          let-rowData
          let-rowIndex="rowIndex"
        >
          <laas-data-table
            #expandedTable
            [tableKey]="detailPreferenceKey"
            [dataKey]="'seqNo'"
            [selectable]="false"
            [value]="customsClearanceShippingReportDetailData"
            [defaultColumns]="detailColumns"
            [totalRecords]="detailPageInfo.totalRecords"
            [lazy]="true"
            (tableOnPage)="detailTablePageChange($event)"
            (tableOnSort)="detailTableSort($event)"
            [style]="{ 'overflow-y': 'auto' }"
          >
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col.field">
                  <ng-container *ngSwitchCase="'updateUser'" class="p-fluid">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping : this.userOptions
                          | replaceNullWith : '-'
                      }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'createUser'" class="p-fluid">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping : this.userOptions
                          | replaceNullWith : '-'
                      }}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <div [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">
                          {{
                            rowData[col.field]
                              | date
                                : "yyyy-MM-dd HH:mm:ss"
                                : this.laasSetting.facilityTimeZone
                              | replaceNullWith : '-'
                          }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith : '-' }}
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </td>
            </ng-template>
          </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>

  <p-dialog
    [(visible)]="showUploadDialog"
    appendTo="body"
    [modal]="true"
    [style]="{width: '60%'}"
    (onHide)="onUploadDialogHide()">
    <div *ngIf="isFileDialogLoading" class="loading-overlay">
      <p-progressSpinner></p-progressSpinner>
    </div>

    <ng-template pTemplate="header">
      {{ "CompanyStampMaintenance.UploadFile.UploadFile" | translate }}
    </ng-template>
    <ng-template pTemplate="content">
      <div class="p-fluid formgrid grid">
        <div class="field col-8">
          <label>
            <span class="requiredStart">*</span>
            {{
              "CustomsClearanceShippingReport.Dialog.Form.CustomsDeclarationNo"
                | translate
            }}
          </label>
          <input
            type="text"
            pInputText
            [(ngModel)]="uploadParams.customsDeclarationNo"
          />
        </div>
      </div>
      <div class="field col-12">
        <label>
          {{ "CompanyStampMaintenance.UploadFile.File" | translate }}
        </label>
        <p-fileUpload
          #fileUpload
          accept=".xls,.xlsx"
          [customUpload]="true"
          (uploadHandler)="fileUploader($event)"
          (onClear)="clearFile()"
          chooseLabel="{{
            'CustomsClearanceShippingReport.Dialog.Button.ChooseFile'
              | translate
          }}"
          uploadLabel="{{
            'CustomsClearanceShippingReport.Dialog.Button.UploadFile'
              | translate
          }}"
          cancelLabel="{{
            'CustomsClearanceShippingReport.Dialog.Button.CancelFile'
              | translate
          }}"
        ></p-fileUpload>
      </div>
    </ng-template>
  </p-dialog>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
